import { render, staticRenderFns } from "./itemsCollectionCustomFieldValues.vue?vue&type=template&id=031c60de&"
import script from "./itemsCollectionCustomFieldValues.vue?vue&type=script&lang=js&"
export * from "./itemsCollectionCustomFieldValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports